// extracted by mini-css-extract-plugin
module.exports = {"eventList":"EventList_eventList__3QgcJ","label":"EventList_label__2ztCy","viewMore":"EventList_viewMore__1P_Po"};